import { Linking } from 'react-native';

/**
 * Safely opens a URL, handling empty strings and invalid URLs gracefully.
 * This prevents "Invalid URL: cannot be empty" errors.
 *
 * @param url - The URL to open
 * @returns Promise<boolean> - true if URL was opened successfully, false otherwise
 */
export async function safeOpenURL(url: string | undefined | null): Promise<boolean> {
  // Check for empty, undefined, or null URLs
  if (!url || typeof url !== 'string' || url.trim() === '') {
    console.warn('safeOpenURL: Attempted to open empty or invalid URL');
    return false;
  }

  try {
    const canOpen = await Linking.canOpenURL(url);
    if (!canOpen) {
      console.warn(`safeOpenURL: Cannot open URL: ${url}`);
      return false;
    }

    await Linking.openURL(url);
    return true;
  } catch (error) {
    console.error('safeOpenURL: Error opening URL:', error);
    return false;
  }
}
